import { useEffect, useState, useRef } from 'react';
import { addNotification } from '../../state/src/notifications-slice';
import { NotificationOptions } from '../../notifications/utils/notification-builder';
import { useDispatch } from 'react-redux';

export const useNotification = () => {
  const [success, setSuccess] = useState<NotificationOptions>();
  const isMounted = useRef(true);
  const [notificationSent, setNotificationSent] = useState(false);
  const [error, setError] = useState<NotificationOptions>();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isMounted.current) {
      showSuccessMessageEffect();
    }

    return () => {
      setSuccess(undefined);
    };

    async function showSuccessMessageEffect() {
      if (success) {
        setNotificationSent(true);
        dispatch(addNotification(success));
      }
    }
  }, [success]);

  useEffect(() => {
    if (isMounted.current) {
      showErrorMessageEffect();
    }

    return () => {
      setError(undefined);
    };

    async function showErrorMessageEffect() {
      if (error) {
        dispatch(addNotification(error));
      }
    }
  }, [error]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      setSuccess(undefined);
      setError(undefined);
    };
  }, []);

  return {
    sendSuccessNotification: setSuccess,
    notificationSent,
    setNotificationSent,
    sendErrorNotification: setError,
  };
};
